import { Box } from '@factorialco/deprecated-design-system'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useAtsContext } from 'modules/ats/lib/atsContext'
import { JoinPromotionSettings } from 'modules/ats/pages/settings/IntegrationsPage/JoinPromotionSettings'
import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CalendarSync } from './CalendarSync'
import { OtherAddons } from './OtherAddons'

const IntegrationsPage = () => {
  const { canManageAtsSettings } = useAtsContext()
  const { loading } = useAsyncData(
    async () => (canManageAtsSettings ? subscriptionAddons.fetch() : false),
    []
  )
  return (
    <ResponsivePage.Body
      authorized={canManageAtsSettings}
      loading={loading}
      error={null}
      showHeader={false}
    >
      <Box gap="s48">
        <JoinPromotionSettings />
        <CalendarSync />
        <OtherAddons />
      </Box>
    </ResponsivePage.Body>
  )
}

export default IntegrationsPage
